import { DEFAULT_SPORT_ID } from '@sportybot-web/services/stats-api/constants';
import { formatScheduleDate } from '@sportybot-web/utils/date';
import { z } from 'zod';

export const homeParamsSchema = z.object({
  date: z.iso
    .date()
    .optional()
    .default(() => formatScheduleDate()),
  sportId: z.number().default(DEFAULT_SPORT_ID),
});

export type HomeParams = z.infer<typeof homeParamsSchema>;
